import { css, Interpolation, Theme } from '@emotion/react'
import { memo } from 'react'
import i18n from '../../utilities/i18n'
import Tip from '../Icons/Tip'
import { getThemeSpacing } from '../styles/appTheme'
import { palette } from '../styles/colors'
import { COMPOSE_ICONS_SPACING } from '../theme'
import IconButton from './IconButton'

const buttonStyles = css({
    border: 0,
    padding: getThemeSpacing(COMPOSE_ICONS_SPACING),
    '& svg': { color: palette.greenLink },
})

interface IButtonTip {
    onClick?(event?: any): any
    overrides?: Interpolation<Theme>
}

const ButtonTip = memo((props: IButtonTip) => {
    const { onClick = () => {}, overrides } = props
    return (
        <IconButton
            css={[buttonStyles, overrides]}
            title={i18n.t('chat.tip')}
            data-testid="IconButton__Tip"
            onClick={onClick}
        >
            <Tip />
        </IconButton>
    )
})

export default ButtonTip
